import { publicCoursesListActionTypes as types } from 'Screens';
import initialState from 'store/InitialState';

export function publicCoursesReducer(state = initialState.publicCoursesMap, action) {
    switch(action.type) {
        case types.LOAD_PUBLIC_COURSES_LIST_SUCCESS:
            return action.publicCoursesMap;
        default:
            return state;
    }
};
export function paginationInfoReducer(state = initialState.paginationInfo, action) {
    switch(action.type) {
        case types.LOAD_PAGINATION_INFO_SUCCESS:
            return action.paginationInfo;
        default:
            return state;
    }
}
